module.exports = __webpack_public_path__ + "static/media/DSC_0122-2.fba75fe5.jpg";